// This file was automatically generated at 2024-03-04T17:48:01.245Z

const config = {
    "env": "staging",
    "features": {
        "manualRepoTransfer": true,
        "codeEditor": true,
        "unifiedLogin": true
    },
    "docsUrl": "https://docs.netlify.com/create/",
    "api": {
        "base_url": "https://stg-api-create.services.netlify.com"
    },
    "app": {
        "base_url": "https://staging--create.netlify.com"
    },
    "core_app": {
        "base_url": "https://app.netlify.com",
        "deploy_preview_domain": "app.netlify.com"
    },
    "stackbit_app": {
        "base_url": "https://staging.app.stackbit.com"
    },
    "scripts": {
        "allowedOrigins": [
            "/localhost:8080$/",
            "/stackbit\\.com$/",
            "/stackbitapp\\.netlify\\.app$/",
            "/create\\.netlify\\.com$/",
            "/preprod-gwp\\.intuit\\.com$/"
        ]
    },
    "marketingSite": {
        "url": "https://www.stackbit.com",
        "tos_url": "https://www.netlify.com/legal/terms-of-use",
        "pricing_url": "https://www.netlify.com/pricing",
        "license_url": "https://www.netlify.com/pdf/self-serve-subscription-agreement.pdf"
    },
    "wizard": {
        "themeBranch": "staging",
        "layerDefaults": {
            "theme": null,
            "ssg": "nextjs",
            "cms": "git",
            "repository": "github",
            "container": "sharedContainer",
            "deployment": "netlify"
        },
        "contactFormRestrictedEmailDomains": [
            "@gmail.com",
            "@protonmail.com",
            "@hotmail.com",
            "@yahoo.com",
            "@aol.com",
            "@outlook.com",
            "@icloud.com",
            "@me.com",
            "@live.com",
            "@qq.com",
            "@pm.me",
            "@googlemail.com",
            "@mail.ru",
            "@yandex.ru"
        ]
    },
    "github": {
        "apiBaseUrl": "https://api.github.com",
        "wizardScope": "repo"
    },
    "bitbucket": {
        "apiBaseUrl": "https://bitbucket.org"
    },
    "datocms": {
        "apiBaseUrl": "https://oauth.datocms.com"
    },
    "sanity": {
        "apiBaseUrl": "https://api.sanity.io/v1",
        "configureUrl": "https://www.sanity.io/manage"
    },
    "netlify": {
        "apiBaseUrl": "https://api.netlify.com/api/v1",
        "connectYourDomainLink": "https://docs.netlify.com/domains-https/custom-domains/configure-external-dns/",
        "anonFlowEnabled": true
    },
    "azure": {
        "resourceManagementBaseUrl": "https://management.azure.com",
        "connectYourDomainLink": "https://docs.microsoft.com/en-us/azure/static-web-apps/custom-domain?tabs=azure-dns/",
        "anonFlowEnabled": false
    },
    "digitalocean": {
        "githubAppLink": "https://cloud.digitalocean.com/apps/github/install",
        "connectYourDomainLink": "https://docs.digitalocean.com/products/app-platform/how-to/manage-domains/"
    },
    "contentful": {
        "apiBaseUrl": "https://api.contentful.com",
        "configureUrl": "https://app.contentful.com/account/organizations"
    },
    "forestry": {
        "apiEnabled": true,
        "apiBaseUrl": "https://app.forestry.io"
    },
    "segment": {
        "writeKey": "HW788rUbGFVg1Tlkm9O6oKw7lSG7bwmR",
        "analyticsEnv": "dev"
    },
    "logging": {
        "logentries": {
            "token": "60787e46-253f-4198-bffd-b3a2b935ca86",
            "logAnalyticsEvents": true,
            "logAnalyticsPageViews": true
        },
        "bugsnag": true,
        "loglevel": true
    },
    "customerio": {
        "enabled": true,
        "siteId": "36bba3dfd19ab0031270"
    },
    "bugsnag": {
        "apiKey": "32f3a667bb834abe530178b46cdca7c9"
    },
    "devCycle": {
        "sdkKey": "dvc_client_46a6b2f8_d143_45db_88de_70b65dce0b58_c798b12"
    },
    "datadog": {
        "applicationId": "7fa792a8-6c0f-437f-a98f-a55365b616b2",
        "clientToken": "pub0fde3e8009ffebf021b09fe1677babb4",
        "service": "dev-create.netlify.com"
    },
    "slack": {
        "sendNotifications": false
    },
    "stripe": {
        "publishableKey": "pk_test_51HZLXhHALtKJW3ReNBdufaYHWmZnRpG75LbhD9TUKdcsFbtw02IEO8Zk0jguMnO6yyKkeUceBNrR6sQnTSQrcVuR00YZGoImyV"
    }
};

export type BaseConfig = {
    "env": string,
    "features": {
        "manualRepoTransfer": boolean,
        "codeEditor": boolean,
        "unifiedLogin": boolean
    },
    "docsUrl": string,
    "api": {
        "base_url": string
    },
    "app": {
        "base_url": string
    },
    "core_app": {
        "base_url": string,
        "deploy_preview_domain": string
    },
    "stackbit_app": {
        "base_url": string
    },
    "scripts": {
        "allowedOrigins": string[]
    },
    "marketingSite": {
        "url": string,
        "tos_url": string,
        "pricing_url": string,
        "license_url": string
    },
    "wizard": {
        "themeBranch": string,
        "layerDefaults": {
            "theme": null,
            "ssg": string,
            "cms": string,
            "repository": string,
            "container": string,
            "deployment": string
        },
        "contactFormRestrictedEmailDomains": string[]
    },
    "github": {
        "apiBaseUrl": string,
        "wizardScope": string
    },
    "bitbucket": {
        "apiBaseUrl": string
    },
    "datocms": {
        "apiBaseUrl": string
    },
    "sanity": {
        "apiBaseUrl": string,
        "configureUrl": string
    },
    "netlify": {
        "apiBaseUrl": string,
        "connectYourDomainLink": string,
        "anonFlowEnabled": boolean
    },
    "azure": {
        "resourceManagementBaseUrl": string,
        "connectYourDomainLink": string,
        "anonFlowEnabled": boolean
    },
    "digitalocean": {
        "githubAppLink": string,
        "connectYourDomainLink": string
    },
    "contentful": {
        "apiBaseUrl": string,
        "configureUrl": string
    },
    "forestry": {
        "apiEnabled": boolean,
        "apiBaseUrl": string
    },
    "segment": {
        "writeKey": string,
        "analyticsEnv": string
    },
    "logging": {
        "logentries": {
            "token": string,
            "logAnalyticsEvents": boolean,
            "logAnalyticsPageViews": boolean
        },
        "bugsnag": boolean,
        "loglevel": boolean
    },
    "customerio": {
        "enabled": boolean,
        "siteId": string
    },
    "bugsnag": {
        "apiKey": string
    },
    "devCycle": {
        "sdkKey": string
    },
    "datadog": {
        "applicationId": string,
        "clientToken": string,
        "service": string
    },
    "slack": {
        "sendNotifications": boolean
    },
    "stripe": {
        "publishableKey": string
    }
};

export type Config = BaseConfig;

export default (config as Config);
